// Core
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Packages
import { Spin, Icon } from 'antd';

// Store
import { getAppTheme } from '../../store/app/getters';

// Layout config
import { COLOR_PRIMARY } from '../../config/Layout';

/**
 * Parses the size of the spinner (uses prop.size)
 * @param size {String|Number} (prop.size) [sm | md | lg | 0-... (px)]
 * @return {number} The size number (in pixels)
 */
const parseSize = (size) => {
  let parsedSize;

  switch (true) {
    case size === '2xsm':
      parsedSize = 12;
      break;
    case size === 'xsm':
      parsedSize = 18;
      break;
    case size === 'sm':
      parsedSize = 28;
      break;
    case size === 'md' || size.trim() === '':
      parsedSize = 42;
      break;
    case size === 'lg':
      parsedSize = 68;
      break;
    default:
      parsedSize = size;
      break;
  }

  return parsedSize;
};

const Spinner = (props) => {
  const {
    testId,
    size,
    color,
    appThemeSlug,
  } = props;

  // SIZE
  const parsedSize = parseSize(size);

  // Icon configuration
  const antIcon = (
    <Icon type="loading" style={{ fontSize: parsedSize, color: color || COLOR_PRIMARY[appThemeSlug] }} spin />
  );

  return (
    <div data-testid={testId} style={{ height: `calc(${parsedSize}px + 10px)` }}>
      <Spin indicator={antIcon} />
    </div>
  );
};

// Prop types
Spinner.propTypes = {
  testId: PropTypes.string,
  appThemeSlug: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

// Prop default values
Spinner.defaultProps = {
  testId: undefined,
  size: 'md',
  color: null,
};

const mapStateToProps = (state) => ({
  appThemeSlug: getAppTheme(state, 'slug'),
});

export default connect(mapStateToProps)(Spinner);
